<template>
    <div class="card cardInfoRegistro" id="cardInfoRegistro">
        <div class="col-12 p-3">
            <p class="subtitle mb-0">{{dataInfoReserva.title}}</p>      
            <p class="notasInfoReserva mt-0">{{dataInfoReserva.hotelCity}}, {{dataInfoReserva.hotelCountry}}</p>
            <hr>
            <p class="tituloInfo">{{$t('language.posadasCorporate.sidebarReserva.hHabitaciones')}}</p>
            <p class="parrafoInfo">{{infoReserva.data.hotel.title}}</p>
            <ul class="listIconModal">
                <li class="row">
                    <i class="demo-icon icon-calendar col-1"></i>
                    <p class="col-10 mb-3 infoHabitacion">{{dataInfoReserva.arrivalDate}} - {{dataInfoReserva.departureDate}}<br>
                    <span class="notasInfoReserva">{{dataInfoReserva.nights}} {{dataInfoReserva.nights===1?$t('language.posadasCorporate.sidebarReserva.noche'):$t('language.posadasCorporate.sidebarReserva.noches')}}</span></p>
                </li>
                <li class="row">
                    <i class="demo-icon icon-bed col-1"></i>
                    <p class="col-10 mb-3 infoHabitacion">{{dataInfoReserva.totalRooms}} {{dataInfoReserva.totalRooms===1?$t('language.posadasCorporate.sidebarReserva.habitacion'):$t('language.posadasCorporate.sidebarReserva.habitaciones')}}<br>
                    <span class="notasInfoReserva">{{dataInfoReserva.rateType}}</span></p>
                </li>
                <li class="row">
                    <i class="demo-icon icon-user col-1"></i>
                    <p class="col-10 mb-3 infoHabitacion">{{dataInfoReserva.totalHuespedes}} {{dataInfoReserva.totalHuespedes===1?$t('language.posadasCorporate.sidebarReserva.huesped'):$t('language.posadasCorporate.sidebarReserva.huespedes')}}<br>
                    <span class="notasInfoReserva">{{dataInfoReserva.totalAdults}} {{dataInfoReserva.totalAdults===1?$t('language.posadasCorporate.sidebarReserva.adulto'):$t('language.posadasCorporate.sidebarReserva.adultos')}}{{dataInfoReserva.totalChildren===0?'':dataInfoReserva.totalChildren===1?', ' + dataInfoReserva.totalChildren + ' ' + $t('language.posadasCorporate.sidebarReserva.menor'): ', ' + dataInfoReserva.totalChildren + ' ' + $t('language.posadasCorporate.sidebarReserva.menores')}}{{dataInfoReserva.totalInfants===0?'':dataInfoReserva.totalInfants===1?', ' + dataInfoReserva.totalInfants + ' ' + $t('language.posadasCorporate.sidebarReserva.infante'): ', ' + dataInfoReserva.totalInfants + ' ' + $t('language.posadasCorporate.sidebarReserva.infantes')}}</span></p>
                </li>
            </ul>
            <hr v-if="banRequerimentt">
             <b-card class="PC-card--collapsible corpo-collapsible" v-if="banRequerimentt">
                <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle="'noche1'">
                        <b>{{$t('language.posadasCorporate.sidebarReserva.requerimientos')}}</b>
                        <small>({{$t('language.posadasCorporate.sidebarReserva.sinCostoAdicional')}})</small>
                    </b-button>
                </b-card-header>
                <b-collapse id="noche1" accordion="Noche1" role="tabpanel">
                    <b-card-body>
                        <section v-if="(requirementsDataH1===null||requirementsDataH1==='.'?false:true)">
                            <p class="PC-text--semibold mb-1">{{$t('language.posadasCorporate.sidebarReserva.hHabitacion')}} 1</p>
                            <small>
                                {{requirementsDataH1}}
                            </small>
                        </section>
                        <section v-if="(requirementsDataH2===null||requirementsDataH2==='.'?false:true)">
                            <p class="PC-text--semibold mb-1">{{$t('language.posadasCorporate.sidebarReserva.hHabitacion')}} 2</p>
                            <small>
                                {{requirementsDataH2}}
                            </small>
                        </section>
                        <section v-if="(requirementsDataH3===null||requirementsDataH3==='.'?false:true)">
                            <p class="PC-text--semibold mb-1">{{$t('language.posadasCorporate.sidebarReserva.hHabitacion')}} 3</p>
                            <small>
                                {{requirementsDataH3}}
                            </small>
                        </section>
                        <section v-if="(requirementsDataH4===null||requirementsDataH4==='.'?false:true)">
                            <p class="PC-text--semibold mb-1">{{$t('language.posadasCorporate.sidebarReserva.hHabitacion')}} 4</p>
                            <small>
                                {{requirementsDataH4}}
                            </small>
                        </section>
                        <section v-if="(requirementsDataH5===null||requirementsDataH5==='.'?false:true)">
                            <p class="PC-text--semibold mb-1">{{$t('language.posadasCorporate.sidebarReserva.hHabitacion')}} 5</p>
                            <small>
                                {{requirementsDataH5}}
                            </small>
                        </section>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <hr>
            <div class="row">

                <div class="col-6">
                    <p class="subtitle mb-0">{{$t('language.posadasCorporate.generals.totalEstanciaImpuestos')}} {{dataInfoReserva.nights}} {{dataInfoReserva.nights===1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches')}}:</p>
                    <p class="notasInfoReserva mt-0">
                        {{dataInfoReserva.totalRooms}} {{dataInfoReserva.totalRooms===1?$t('language.posadasCorporate.sidebarReserva.habitacion'):$t('language.posadasCorporate.sidebarReserva.habitaciones')}}
                    </p>
                </div>
                <div class="col-6">
                    <br><br><br>
                    <p class="subtitle mb-0">$ {{ ((infoCosto.data.userClientID===pyp||infoCosto.data.userClientID===pypsa||!showRates)&&infoCosto.data.tabActive===1?guiones:globalFunctions.numberFormat(dataInfoReserva.totalRateWithTaxes, 2, '.', ',')) }} <span class="moneda">{{dataInfoReserva.currencyCode}}</span></p>
                    <p class="text-right ver-detalleInfoReserva">
                        <a class="enlaceDetalle" @click="verDetalle()" onclick="return false;" href="#">
                            {{$t('language.posadasCorporate.sidebarReserva.verDetalle')}}
                        </a>
                    </p>
                </div>
            </div>
        </div>

        <DetalleCostos v-if="banDetCost"  :key="componentKey"></DetalleCostos> 
    </div>
</template>

<script>
    import * as GlobalFunctions from "../../utils/GlobalFunctions";
    import DetalleCostos from './DetalleCostos';
    import moment from 'moment';
    import SecureLS from 'secure-ls';

    export default {
        name: 'SidebarReserva',
        components: {
            DetalleCostos,
        },
        props: {
            infoReserva: Object,
            banRequeriment: Boolean
        },
        data:() => {
            return {
                plusDeChambres: 1,
                currentLocation: "",
                originalValue: 0,
                supplemnFinal: 0,
                pyp: 'PYP', //no cambiar este valor
                pypsa: 'PYPSA', //no cambiar este valor
                guiones: '-------', //no cambiar este valor
                showRates: null,
                componentKey: 0,
                totalTaxesDetail: 0,
                totalStayWithOptionalSupplements: 0,
                ls: new SecureLS({encodingType: 'aes'}),
                globalFunctions: GlobalFunctions,
                banDetCost: false,
                infoCosto: null,
                banRequerimentt: false,
                dataInfoReserva: {
                    userClientID: null,
                    title: null,
                    subTitle: null,
                    arrivalDate: null,
                    departureDate: null,
                    currencyCode: null,
                    nights: null,
                    totalRooms: null,
                    rateType: null,
                    totalHuespedes: null,
                    totalAdults: null,
                    totalChildren: null,
                    totalInfants: null,
                    totalRateWithTaxes: null,
                    hotelCountry: null,
                    hotelCity: null
                },
                requirementsDataH1: null,
                requirementsDataH2: null,
                requirementsDataH3: null,
                requirementsDataH4: null,
                requirementsDataH5: null,
            }
        },
        methods: {
            requeriment(){
                this.banRequerimentt = this.banRequeriment;

                if (this.banRequeriment) {
                    var reqDatH1 = this.ls.get('requirementsDataH1');
                    if (reqDatH1 != '') {
                        var list = [];
                        list.push(reqDatH1.extraPreferencesText);
                        list.push(reqDatH1.floorPreferencesText);
                        list.push(reqDatH1.preferencesText);
                        list.push(reqDatH1.smokingPreferencesText);
                        list = list.filter(value => Object.keys(value).length !== 0);
                        this.requirementsDataH1 = list.join(', ') + '.';
                    }
                    
                    var reqDatH2 = this.ls.get('requirementsDataH2');
                    if (reqDatH2 != '') {
                        var list1 = [];
                        list1.push(reqDatH2.extraPreferencesText);
                        list1.push(reqDatH2.floorPreferencesText);
                        list1.push(reqDatH2.preferencesText);
                        list1.push(reqDatH2.smokingPreferencesText);
                        list1 = list1.filter(value => Object.keys(value).length !== 0);
                        this.requirementsDataH2 = list1.join(', ') + '.';
                    }
                    var reqDatH3 = this.ls.get('requirementsDataH3');
                    if (reqDatH3 != '') {
                        var list3 = [];
                        list3.push(reqDatH3.extraPreferencesText);
                        list3.push(reqDatH3.floorPreferencesText);
                        list3.push(reqDatH3.preferencesText);
                        list3.push(reqDatH3.smokingPreferencesText);
                        list3 = list3.filter(value => Object.keys(value).length !== 0);
                        this.requirementsDataH3 = list3.join(', ') + '.';
                    }
    
                    var reqDatH4 = this.ls.get('requirementsDataH4');
                    if (reqDatH4 != '') {
                        var list4 = [];
                        list4.push(reqDatH4.extraPreferencesText);
                        list4.push(reqDatH4.floorPreferencesText);
                        list4.push(reqDatH4.preferencesText);
                        list4.push(reqDatH4.smokingPreferencesText);
                        list4 = list4.filter(value => Object.keys(value).length !== 0);
                        this.requirementsDataH4 = list4.join(', ') + '.';
                    }
    
                    var reqDatH5 = this.ls.get('requirementsDataH5');
                    if (reqDatH5 != '') {
                        var list5 = [];
                        list5.push(reqDatH5.extraPreferencesText);
                        list5.push(reqDatH5.floorPreferencesText);
                        list5.push(reqDatH5.preferencesText);
                        list5.push(reqDatH5.smokingPreferencesText);
                        list5 = list5.filter(value => Object.keys(value).length !== 0);
                        this.requirementsDataH5 = list5.join(', ') + '.';
                    }
                }
            },
             /*Eventos para cambios en el ancho de la pagina*/
            getWindowWidth: function (event) {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowWidth > 736 ? this.device = 'desktop' : this.device = 'mobile';
            },
            verDetalle(){
                this.componentKey += 1;
                this.banDetCost = true;
                    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = this.totalTaxesDetail;
                    this.ls.set('moreStayingTaxesMinor',this.totalTaxesDetail);
                    this.ls.set('updateCostDetail', this.infoCosto );
                setTimeout(() => {
                    this.$bvModal.show('detalleDeCosto1');
                }, 20);
            },
             verDetalleInit(){
                this.componentKey += 1;
                    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = this.totalTaxesDetail;
                    this.ls.set('moreStayingTaxesMinor',this.totalTaxesDetail);
                    this.ls.set('updateCostDetail', this.infoCosto );
            },
        },
        computed: {
                readButton() {
                        return this.$store.getters.getButton
                },
            optionalSupplements() {
                        return this.$store.getters.getOptionalSupplements
            },
            monitorSupp() {
                return this.ls.get('updateCostDetail')
            }
        },
        watch: {
             readButton() {
                         if(this.readButton) {
                             this.verDetalleInit()
                         } 
             },
            currentLocation() {
                    if(this.currentLocation.pathname == "/reservaciones-metodos-pago") {
                            this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = this.totalTaxesDetail;
                  this.ls.set('moreStayingTaxesMinor',this.totalTaxesDetail);
                  this.ls.set('updateCostDetail', this.infoCosto );
                    }
            },
            optionalSupplements() {
                    this.dataInfoReserva.totalRateWithTaxes = this.originalValue
                    var extraSupE = 0
                    var extraSupIE = 0
                    var extraToSE = 0 
                    var extraSupEFirstNight = 0
                    var extraSupIEFirstNight = 0
                    var extraToSEFirstNight = 0 
                    var ob = {
                                extraSupE: extraSupE,
                                extraSupIE: extraSupIE,
                                extraToSE: extraToSE
                            }
                    var ob2 = {
                                extraSupE: extraSupEFirstNight,
                                extraSupIE: extraSupIEFirstNight,
                                extraToSE: extraToSEFirstNight
                            }
                            this.ls.set('supleCondiOneFirstNight', ob2)
                            this.ls.set('supleCondi', ob)
                    if(this.ls.get('nuitsPourS') != null && this.ls.get('nuitsPourS') != "") {
                        var numNuits = this.ls.get('nuitsPourS')
                    } else {
                        var numNuits = 1
                    }
                    var suplObject = (this.$store.getters.getOptionalSupplements.optionalSupplementsObject==undefined||this.$store.getters.getOptionalSupplements.optionalSupplementsObject==null?[]:this.$store.getters.getOptionalSupplements.optionalSupplementsObject)
                    for(var i=0; i < suplObject.length; i++) {
                    switch(suplObject[i].reqOpcional.quantityType) {
                        case 5:
                    extraSupE += suplObject[i].reqOpcional.amount / numNuits
                    for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                        if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                            extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                        }
                    }
                    extraToSE += (extraSupIE + extraSupE)
                    var obje = {
                        extraSupE: extraSupE,
                        extraSupIE: extraSupIE,
                        extraToSE: extraToSE
                    }
                    this.ls.set('supleCondi', obje)
                    break;
                case 3:
                    extraSupE += suplObject[i].reqOpcional.amount / numNuits
                    for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                        if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                            extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                        }
                    }
                    extraToSE += (extraSupIE + extraSupE)
                    var obje = {
                        extraSupE: extraSupE,
                        extraSupIE: extraSupIE,
                        extraToSE: extraToSE
                    }
                    this.ls.set('supleCondi', obje)
                    break;
                case 8:   
                    extraSupE += suplObject[i].reqOpcional.amount / numNuits
                    for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                        if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                            extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                        }
                    }
                    extraToSE += (extraSupIE + extraSupE)
                    var obje = {
                        extraSupE: extraSupE,
                        extraSupIE: extraSupIE,
                        extraToSE: extraToSE
                    }
                    this.ls.set('supleCondi', obje)
                    break;
                case 1:  case 7:     
                        extraSupE += suplObject[i].reqOpcional.amount / numNuits
                        for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                            if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                                extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                            }
                        }
                        extraToSE += (extraSupIE + extraSupE)
                        var obje = {
                            extraSupE: extraSupE,
                            extraSupIE: extraSupIE,
                            extraToSE: extraToSE
                        }
                        this.ls.set('supleCondi', obje)
                        break;
                        case 2: case 6:
        extraSupEFirstNight += suplObject[i].reqOpcional.amount 
        for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                extraSupIEFirstNight += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount 
            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
        case 4:
                 extraSupEFirstNight += suplObject[i].reqOpcional.amount 
        for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount 
            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
    default:
        break;
} 
}
this.totalStayWithOptionalSupplements = 0
this.totalTaxesDetail = 0
if(this.$store.getters.getOptionalSupplements.optionalSupplementsObject == null || this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length == 0) {
this.dataInfoReserva.totalRateWithTaxes = this.originalValue
this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = 0
this.totalStayWithOptionalSupplements = 0
this.totalTaxesDetail = 0
} else {
for(var i = 0; i <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length; i++) {
this.totalStayWithOptionalSupplements += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.amount
for(var j = 0; j <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
 this.totalStayWithOptionalSupplements += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
 this.totalTaxesDetail += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
}
}
this.ls.set("totalSupplements", this.totalStayWithOptionalSupplements - this.totalTaxesDetail)
this.ls.set("totalSupplementsTax",  this.totalTaxesDetail)
             this.ls.set('moreStayingTaxes',  this.totalStayWithOptionalSupplements)
this.dataInfoReserva.totalRateWithTaxes += (this.totalStayWithOptionalSupplements * this.plusDeChambres)
this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = this.totalStayWithOptionalSupplements
}
            },
        },
        mounted() {
  this.$nextTick(function () {
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth();
                if (this.position != 'top' && this.device === 'desktop') {
                let aside = document.getElementById('cardInfoRegistro');
                $(window).on("scroll", function(){
                    if ($(this).scrollTop() >= $('#site-footer').offset().top - $(this).height()){
                        aside.classList.add('asideAbsoluteDetalle')
                    } else {
                        aside.classList.remove('asideAbsoluteDetalle')
                    }
                });
                }
            });
        },
        created(){
            var currentLocation = window.location;
            this.currentLocation = window.location
            if(currentLocation.pathname == "/reservaciones-metodos-pago" ) {
            var persistentData = this.$store.getters.getOptionalSupplements
                this.$store.commit('updateTotalStay', {optionalSupplementsObject: persistentData.optionalSupplementsObject})
            }
            this.showRates = this.ls.get('Profile').data.ratesPermissionsResponse.showRates;
            this.plusDeChambres = this.infoReserva.data.habitacion.totalRooms
            this.requeriment();
            if (this.infoReserva.data.localStor === 'datosHabHotSelected') {
                this.infoCosto = this.infoReserva;
                this.dataInfoReserva.title = this.infoReserva.data.hotelName;
                this.dataInfoReserva.subTitle = this.infoReserva.data.hotel.title;
                          if(this.ls.get('roomNameSW') != null && this.ls.get('allowF')) {
                                this.dataInfoReserva.subTitle = this.ls.get('roomNameSW') 
                                this.infoReserva.data.hotel.title = this.ls.get('roomNameSW') 
                          }
            this.dataInfoReserva.arrivalDate = this.infoReserva.data.habitacion.beautiDateInput;
            this.dataInfoReserva.departureDate = this.infoReserva.data.habitacion.beautiDateOutput;    
                this.dataInfoReserva.currencyCode = this.infoReserva.data.habitacion.currencyCode;
                this.dataInfoReserva.nights = this.infoReserva.data.hotel.nights;
                this.dataInfoReserva.totalRooms = this.infoReserva.data.habitacion.totalRooms;
                this.dataInfoReserva.rateType = this.infoReserva.data.hotel.negotiatedRatesDetailPrice.rateType;
                this.dataInfoReserva.totalHuespedes = (this.infoReserva.data.habitacion.totalAdults + this.infoReserva.data.habitacion.totalChildren + this.infoReserva.data.habitacion.totalInfants);
                this.dataInfoReserva.totalAdults = this.infoReserva.data.habitacion.totalAdults;
                this.dataInfoReserva.totalChildren = this.infoReserva.data.habitacion.totalChildren;
                this.dataInfoReserva.totalInfants = this.infoReserva.data.habitacion.totalInfants;
                this.dataInfoReserva.totalRateWithTaxes = this.infoReserva.data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes;
                this.originalValue = this.infoReserva.data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes;
               this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
                this.dataInfoReserva.hotelCity = this.infoReserva.data.cityDir;
                this.dataInfoReserva.hotelCountry = this.infoReserva.data.countryDir;
            }
      if(this.$store.getters.getOptionalSupplements == null || this.$store.getters.getOptionalSupplements == undefined || this.$store.getters.getOptionalSupplements == '' || this.$store.getters.getOptionalSupplements.length == 0) {

        } else {
            if(this.$store.getters.getOptionalSupplements.optionalSupplementsObject === undefined || this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length == 0) {
            this.dataInfoReserva.totalRateWithTaxes -= ( this.totalStayWithOptionalSupplements * this.plusDeChambres )
            this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
            this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = 0
            this.totalStayWithOptionalSupplements = 0
            this.totalTaxesDetail = 0
            } else {
            for(var i = 0; i <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length; i++) {
            this.totalStayWithOptionalSupplements = this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.amount
            for(var j = 0; j <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
            this.totalStayWithOptionalSupplements += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
            this.totalTaxesDetail += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
            }
            }
             this.ls.set('moreStayingTaxes',  this.totalStayWithOptionalSupplements)
            this.dataInfoReserva.totalRateWithTaxes += ( this.totalStayWithOptionalSupplements * this.plusDeChambres )
            this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
            this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = this.totalStayWithOptionalSupplements
}
  }
        }
    }
</script>

<style lang="scss" scoped>
  .cardInfoRegistro {
    position: fixed;
    max-width: 290px;
  }
  .tituloInfo {
    font-size: 15px;
    font-weight: bold;
  }
  .parrafoInfo {
    font-size: 14px;
    font-weight: 500;
  }
  .infoHabitacion {
    font-size: 14px;
    font-weight: normal;
  }
  .demo-icon {
    font-size: 18px;
  }
  .icon-info {
    color: #0c5458 !important;
    font-size: 18px !important;
  }
  .icon-Cerrar {
    font-size: 24px;
    color: #005a83;
  }
  .moneda {
    font-size: 12px;
    font-weight: 500;
  }
  .enlaceDetalle {
    font-size: 14px;
    font-weight: 500;
    color: #005a83;
  }
  .costosTable {
    width: 50%;
    display: inline-block;
    padding-bottom: 10px;
  }
  @media only screen and (max-width: 736px) {
    .costosTable {
      width: 100%;
      display: inline-block;
    }
  }
</style>